import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'

import LCombobox from '@/components/core/Combobox.vue'
import LocationForm from '@/components/trip/transportation/forms/generic/LocationForm.vue'
import { TransportationSubType, TransportationType } from '@/utils/enums'
import { i18n } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'GenericForm',
  emits: ['click:add'],
  setup(__props, { emit: emits }) {

const type = TransportationType.GENERIC



const subTypeComboboxItems = Object.values(TransportationSubType).map(
  (subType) => ({
    label: i18n.t(subType).toString(),
    value: subType,
  }),
)

const selectedSubType = ref()
const inputValue = ref('')
watch(selectedSubType, (newSubType) => {
  inputValue.value = i18n.t(newSubType).toString()
})

const transportationImage = computed(() => {
  if (selectedSubType.value && selectedSubType.value !== '') {
    return `transport_${selectedSubType.value}.png`
  }
  return 'icon_hashtag@3x.png'
})

// reset form when creating booking
function onAdd() {
  selectedSubType.value = undefined
  emits('click:add')
}

return { __sfc: true,type, emits, subTypeComboboxItems, selectedSubType, inputValue, transportationImage, onAdd, LCombobox, LocationForm }
}

})